// on the plp, store the url. separate script runs on the pdp to check local storage

if (window.location.href.indexOf("collections") > -1) {
  let relativeUrl = window.location.href.split("collections")[1];
  if (relativeUrl.includes('?')) {
    relativeUrl = relativeUrl.split("?")[0];
  }
  localStorage.setItem("prevPage", `/collections${relativeUrl}`);
}
